// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"604":"d49a1279","857":"7e136d4b"}[chunkId] + ".chunk.js";
};